import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography'
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import _ from 'lodash'
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl  from '@material-ui/core/FormControl';
import FormControlLabel  from '@material-ui/core/FormControlLabel';
import FormGroup  from '@material-ui/core/FormGroup';
import Button from '@material-ui/core/Button';
import {withRouter} from "react-router-dom";
import { inject, observer } from 'mobx-react';
import { autorun } from 'mobx';
import {pending, done, error} from '../stores/State'
import Checkbox from '@material-ui/core/Checkbox';
import TextField from '@material-ui/core/TextField';
import Chip from '@material-ui/core/Chip';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Dialog from '@material-ui/core/Dialog';

@inject('store')
@observer
/**
 * This class will display Create/Edit view for Customer object
 */
class EditCustomer extends Component {
  static propTypes = {
    isNew: PropTypes.bool
  }

  componentWillMount(){
    const store = this.props.store.customerStore;

    //IF this is a new Customer
    if(this.props.isNew){
      //Create new instance
      store.createCustomer(_.toInteger(this.props.match.params.accountId));
      
      //Add autorun handler to watch when saveState is done
      this.autorunHandler = autorun(()=>{
        if(_.get(store.newCustomer, 'saveState') === done) this.props.history.push(`/customers/${store.newCustomer.saveResult.id}`)
      })
    }
    //Editing old Customer
    else{
      //Fetch it
      this.fetchCustomer();

      //Add autorun handler to watch when saveState is done
      this.autorunHandler = autorun(()=>{
        if(_.get(store.customer, 'saveState')  === done) this.props.history.push(`/customers/${store.customer.id}`)
      })
      //Add autorun handler to watch when archiveState is done
      this.autorunHandler = autorun(()=>{
        if(_.get(store.customer, 'archiveState')  === done) this.props.history.push(`/accounts/${store.customer.account.id}`)
      })
    }
 }

  componentWillUnmount(){
    //Release autorun handler
    this.autorunHandler();
  }

  /**
   * Fetch existing customer using match.params.id
   */
  fetchCustomer(){
    const store = this.props.store.customerStore;
    store.fetchCustomer(this.props.match.params.id);
  }

  /**
   * Get the customer from store
   */
  get customer(){
    return this.props.isNew ? this.props.store.customerStore.newCustomer : this.props.store.customerStore.customer;
  }

  /**
   * Render recipients we are adding
  */
  renderRecipients(){
    const { classes } = this.props;
    const customer  = this.customer;
    
    if(!customer) return null;

    //Render the Chips
    return customer.feedback_recipients.map((email)=>(
        <Chip
        label={email}
        key={email}
        onDelete={()=>customer.removeRecipient(email)}
        className={classes.chip}
      />
    ))
  }

  /**
   * Recipient text field has changed
  */
  handleRecipientChanged(event){
    const store = this.props.store.customerUIStore;
    //Set email to uiStore. This also makes it dirty.
    store.setRecipientEmail(event.target.value);
  }

  /**
   * Add recipient to customer. Also clear email from uiStore.
   */
  handleAddRecipient(){
    const customer  = this.customer;
    const uiStore = this.props.store.customerUIStore;
    customer.addRecipient(uiStore.recipientEmail);
    //Also clear recipient email. This also marks it non-dirty.
    uiStore.clearRecipientEmail();
  }

  /**
   * Render errors for key from errors object
   */
  renderErrors(errors, key){
    const uiStore = this.props.store.customerUIStore;    
    if(!errors) return null;
    if(!uiStore.dirty[key]) return null;
    
    const _errors = errors[key];
    if(!_errors) return null;
    return _errors.map((error)=><Typography key={error} color='error'>{error}</Typography>)
  }

  handleShowArchiveDialog = () => {
    this.props.store.customerUIStore.openArchiveDialog();
  }

  renderDialog() {
      const uiStore = this.props.store.customerUIStore;    

      return <Dialog
        open={uiStore.archiveDialogOpen}
        onClose={this.handleDialogClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">Archive customer</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Are you sure you want to archive this customer?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={this.handleDialogClose} color="primary">
            Cancel
          </Button>
          <Button onClick={this.handleArchiveCustomer} color="primary" autoFocus>
            Archive
          </Button>
        </DialogActions>
      </Dialog>
  }

  handleDialogClose = () => {
    this.props.store.customerUIStore.closeArchiveDialog();
  }

  handleArchiveCustomer = () => {
    this.customer.archive();
    this.handleDialogClose();
  }
  
  render() {
    //Get stores
    const uiStore = this.props.store.customerUIStore;    
    
    const { classes, isNew } = this.props;
    //Get current customer we are crating/editing
    const customer  = this.customer;
    if(!customer) return null;
    
    return (
      <Grid container spacing={24} direction='column'>
        {this.renderDialog()}
        <Grid item xs={12}>
            <Typography variant='display3'>{isNew ? 'Create new customer' : customer.name}</Typography>
        </Grid>
        <Grid item xs={12} md={6}>
          <Paper className={classes.paper}>
              <Grid container spacing={24}>
                  <Grid item xs={12}>
                    <FormControl fullWidth={true}>
                      <InputLabel htmlFor="name">Customer name</InputLabel>
                      <Input id="name" value={customer.name} onChange={(event)=>{
                        customer.setName(event.target.value);
                        uiStore.setDirty('name');
                      }} />
                    </FormControl>
                    {this.renderErrors(customer.errors, 'name')}

                    <FormGroup row>
                      <FormControlLabel control={
                        <Checkbox checked={customer.creating_terminal_locations_allowed} onChange={(event)=>customer.setCreatingTerminalLocationsAllowed(event.target.checked)} />
                      }
                      label="Creating terminal locations allowed"/>
                    </FormGroup>

                    <FormGroup row>
                      <FormControlLabel control={
                        <Checkbox checked={customer.cross_customer_transactions_allowed} onChange={(event)=>customer.setCrossCustomerTransactionsAllowed(event.target.checked)} />
                      }
                      label="Cross-customer transactions allowed"/>
                    </FormGroup>
                  </Grid>
                </Grid>
          </Paper>
          </Grid>

          {(customer.cross_customer_transactions_allowed || customer.creating_terminal_locations_allowed) && <Grid item xs={12} md={6}>
          <Paper className={classes.paper}>
              <Typography className={classes.title} variant='title'>Quality complaint recipients</Typography>
              <div className={classes.recipientsContainer}>
                {this.renderRecipients()}
              </div>
              <TextField
                label='Recipient email'
                type='email'
                className={classes.recipientTextField}
                value={uiStore.recipientEmail}
                onChange={this.handleRecipientChanged.bind(this)}
              />
              <Button
                onClick={()=>this.handleAddRecipient()}
                type="submit"
                variant="contained"
                size="small"
                disabled={_.has(uiStore.errors, 'recipientEmail')}>Add recipient
              </Button>
              {this.renderErrors(uiStore.errors, 'recipientEmail')}
            </Paper>
          </Grid>}

          <Grid item xs={12}>
            <Button className={classes.saveButton} color="primary" disabled={customer.errors} variant="contained" type="submit" onClick={()=>customer.save()}>Save</Button>
            {!isNew && <Button disabled={customer.errors} variant="contained" type="submit" onClick={this.handleShowArchiveDialog}>Archive</Button>}
          </Grid>
        </Grid>
    );
  }
}

const styles = theme => ({
  paper:{
    padding: 20,
  },
  chip: {
    margin: 4,
  },
  recipientTextField:{
    marginRight: 5,
    width: 300
  },
  recipientsContainer:{
    display: 'flex',
    flexWrap: 'wrap',
  },
  saveButton: {
    marginRight: 10
  }
});

export default withRouter(withStyles(styles)(EditCustomer));


// WEBPACK FOOTER //
// ./src/components/EditCustomer.js